// extracted by mini-css-extract-plugin
export default {"body":"Sidebar_body__PrR-z","icons":"Sidebar_icons__lHWAQ","logoContainer":"Sidebar_logoContainer__khjTp","logOut":"Sidebar_logOut__-OwR4","profileMenu":"Sidebar_profileMenu__RhIoP"};